<template>

  <div>
    <div
      class="dragfiles"
      ref="dragfiles">
      
      <div class="target">
        <creating
          v-if="loading" />
        <span
          v-if="!loading">{{ $t('Drag or click to select files') }}</span>
      </div>
      <form ref="form">
        <input
          type="file"
          class="form-control"
          :multiple="multiple"
          @change="uploadFile($event)"
          :accept="acceptInLine">
      </form>
    </div>
    <div
      v-if="errorSizeLimit"
      class="alert alert-warning">
      O arquivo deve ter no máximo 3,4Mb.
    </div>
  </div>

</template>

<script>
// import FileReader from '@/utils/FileReader'

export default {
  name: 'InputDropMedia',
  components: {
  },
  props: {
    'value': {
      type: Array,
      default: () => { return [] }
    },
    'multiple': {
      type: Boolean,
      default: true
    },
    'type': {
      type: String,
      default: null
    }
  },
  data () {
    return {
      loading: false,
      errorSizeLimit: false
    }
  },
  computed: {
    accepts () {
      if (this.type === 'image') {
        return ['image/png', 'image/jpeg', 'image/gif']
      }
      return []
    },
    acceptInLine () {
      return this.accepts.join(', ')
    }
  },
  mounted () {
    this.$refs.dragfiles.addEventListener('dragover', function (event) {
      event.target.parentElement.classList.add('dragover')
    }, false)

    this.$refs.dragfiles.addEventListener('dragleave', function (event) {
      event.target.parentElement.classList.remove('dragover')
    }, false)

    this.$refs.dragfiles.addEventListener('drop', function (event) {
      event.target.parentElement.classList.remove('dragover')
    }, false)
  },
  methods: {
    uploadFile (event) {
      this.loading = true
      const files = Object.values(event.target.files)

      Promise.all(files.map(file => {
        if (this.accepts.length && !this.accepts.includes(file.type)) {
          return null
        }

        const formData = new FormData()
        formData.append('file', file)
        return this.$store.dispatch('createMediaMultipart', formData)

        // return FileReader(file)
        // .then((base64) => {
        //   return {
        //     'title': file.name,
        //     'base64': base64
        //   }
        // })
        // .then((data) => {
        //   return this.$store.dispatch('createMedia', data)
        // })
      }))
      .then(result => {
        this.$refs.form.reset()
        this.loading = false
        this.$emit('input', result.filter(v => v))
      }).catch(err => {
        if (err.response.status === 413) {
          this.errorSizeLimit = true
          this.loading = false
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dragfiles {
  position: relative;
}
  .dragfiles .target {
    padding: 5em 2em;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #ffffff;
    outline: 2px dashed #92b0b3;
    outline-offset: -10px;  
    text-align: center;
  }
  .dragfiles input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }
  .dragfiles.dragover .target{
    outline: 4px dashed #e1c97d;
    outline-offset: -15px;
    background: #fff3cd;
  }
</style>



// WEBPACK FOOTER //
// src/components/Fields/InputDropMedia.vue